import axios from 'axios';
import type { PenaltyResponse } from '../types';

const API_URL = '';

interface PenaltyInput {
  file?: File | null;
  text?: string;
}

export async function calcPenaltyFile(input: PenaltyInput, signal?: AbortSignal) {
  const formData = new FormData();
  if (input.file) {
    formData.append('file', input.file);
  } else {
    formData.append('text', input.text || '');
  }
  return axios.post<PenaltyResponse>(`${API_URL}/api/penalty/file`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600_000,
    signal,
  });
}
